import process from 'process';
import { Buffer } from 'buffer';
import { useEffect } from 'react';
import { GraphQLError } from 'graphql';
import { useDbFunctions } from './talons';
import RouterProvider from '@/routes/index';
import { RemoteConfigProvider } from './hooks';
import { onError } from '@apollo/client/link/error';
import { LoaderProvider } from './hooks/LoaderContext';
import { setContext } from '@apollo/client/link/context';
import { setWasmUrl } from '@lottiefiles/dotlottie-react';
import { getOnStorage, removeFromStorage } from './shared';
// import ErrorBoundary from './components/ErrorBoundary';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ModalTimeChange from './components/modal-time-change/ModalTimeChange';
import { from, HttpLink, ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';

import { clarity } from 'react-microsoft-clarity';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  },
});

import {
  AlertProvider,
  UserProvider,
  FetchProvider,
  TablesProvider,
  GlobalProvider,
  ClientProvider,
  TimeMonitorProvider,
  ClientHierarchyProvider,
  useNetworkStatusContext,
} from '@/hooks';

window.Buffer = Buffer;
window.process = process;

const log = console.log;

console.log = (val: any, ...params: any[]) => {
  if (!window.location.href.includes('pwa-rca-prod.bateforte')) {
    log(val, ...params);
  }
};

const App = () => {
  const { updateConnectivityStatus, connectivityStatus } = useNetworkStatusContext();

  const { deleteDB } = useDbFunctions();

  clarity.init('mvfp9i5cf0');

  const httpLink = new HttpLink({
    uri: window.agp_config.MAGENTO_URL,
  });

  useEffect(() => {
    setWasmUrl(`${process.env.PUBLIC_URL}/dotlottie-player.wasm`);
  }, []);

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration?.active?.postMessage({
        type: 'CONFIG',
        config: window.agp_config,
      });
    });
  }

  const authLink = setContext(async (operation, { headers }) => {
    const token = getOnStorage('token_magento');

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json; charset=utf-8',
      },
    };
  });

  const errorHandlerLink = onError(({ networkError, graphQLErrors }) => {
    if (networkError) {
      updateConnectivityStatus('offline');
    } else if (graphQLErrors?.length) {
      if (connectivityStatus === 'online') {
        const err = graphQLErrors?.find(({ extensions }) => {
          return extensions?.category ?? null;
        }) as GraphQLError;

        const errorCategory = err?.extensions?.category as string;

        if (errorCategory?.toLowerCase()?.includes('authorization')) {
          removeFromStorage('login_date');
          removeFromStorage('token_magento');
          removeFromStorage('token_aws');
          removeFromStorage('rca');
          removeFromStorage('selected_client');
          removeFromStorage('datasets');
          removeFromStorage('discounts');
          removeFromStorage('rca_usuario');
          removeFromStorage('cart_id');
          removeFromStorage('user_login_data');
          deleteDB();
          window.alert('Sessão expirada. Por favor, entre com sua conta novamente.');
          window.location.reload();
        }
      }
    }
  });

  const shouldReload = window.localStorage.getItem('reload');
  if (shouldReload) {
    window.localStorage.removeItem('reload');
    window.location.reload();
  }

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: from([authLink, errorHandlerLink, httpLink]),
  });

  return (
    // <ErrorBoundary>
    <ApolloProvider client={client}>
      <QueryClientProvider client={queryClient}>
        <FetchProvider>
          <RemoteConfigProvider>
            <TablesProvider>
              <LoaderProvider>
                <ClientProvider>
                  <UserProvider>
                    <GlobalProvider>
                      <TimeMonitorProvider>
                        <ClientHierarchyProvider>
                          <AlertProvider>
                            {/* <PricesProvider> */}
                            {/* <StockProvider> */}
                            {/* <DiscountFlexProvider> */}
                            {/* <CartProvider> */}
                            {/* <DiscountFlexAmountProvider> */}
                            {/* <CartTotalsProvider> */}
                            <ModalTimeChange />
                            <RouterProvider />
                            {/* </CartTotalsProvider> */}
                            {/* </DiscountFlexAmountProvider> */}
                            {/* </CartProvider> */}
                            {/* </DiscountFlexProvider> */}
                            {/* </StockProvider> */}
                            {/* </PricesProvider> */}
                          </AlertProvider>
                        </ClientHierarchyProvider>
                      </TimeMonitorProvider>
                    </GlobalProvider>
                  </UserProvider>
                </ClientProvider>
              </LoaderProvider>
            </TablesProvider>
          </RemoteConfigProvider>
        </FetchProvider>
      </QueryClientProvider>
    </ApolloProvider>
    // </ErrorBoundary>
  );
};

export default App;
